/**
 * {@link https://drafts.csswg.org/css-flexbox-1/#flex-container}
 *
 * @internal
 */
export function isFlexContainer(style) {
    const [_, inside] = style.computed("display").value.values;
    return inside?.value === "flex";
}
//# sourceMappingURL=is-flex-container.js.map